import { withZones } from '@beef/react';
import { compose } from '@beef/utils';
import { withOnScreenAnalytics } from "../../../../../../../../utils/withOnScreenAnalytics";
import { getWindow } from "../../../../../../../../utils/window";
import { getAccountType } from "../../../../../../../../utils/analytics";
import { ymPushParams } from "../../../../../../../../utils/ym.alternative";
import { onScreenAnalyticsHandler } from "./analytics";
import { EChild } from "../constants";
export var withLayoutAnalytics = function withLayoutAnalytics(WrappedComponent) {
  return compose(withZones(Object.keys(EChild)), withOnScreenAnalytics(function () {
    return onScreenAnalyticsHandler({
      getWindow: getWindow,
      getAccountType: getAccountType,
      ymPushParams: ymPushParams
    });
  }, {
    shouldTriggerOnce: true,
    debounce: 100
  }))(WrappedComponent);
};